module.exports = __webpack_public_path__ + "static/media/ic_wolly.3efd8f12.png";